import type { CSSProperties } from "react";

/**
 * Los valores dinámicos (sangría de una línea, peso de un componente, color de
 * una serie) viajan como custom properties, no como longitudes inline: el
 * número entra sin unidades y el `rem` lo pone el CSS.
 *
 *   <div style={cssVars({ "--line-indent": indent })} />
 *   .stmt__label { padding-inline-start: calc(var(--line-indent) * var(--space-4)); }
 */
export function cssVars(vars: Record<string, string | number>): CSSProperties {
  return vars as CSSProperties;
}
